export default __webpack_public_path__ + "static/sustainability-c52724908a94f06a7bb1cf59f886d328.jpeg";